import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import Today from "@/pages/today/page";
import Topics from "@/pages/topics/page";
import Topic from "@/pages/topic/page";
import ArticleDetail from "@/pages/article/page";
import Faq from "@/pages/faq/page";
import About from "@/pages/about/page";
import Contact from "@/pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: "today", element: <Today /> },
      { path: "topics", element: <Topics /> },
      { path: "topic/:slug", element: <Topic /> },
      { path: "article/:id", element: <ArticleDetail /> },
      { path: "faq", element: <Faq /> },
      { path: "about", element: <About /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;